const stats = [
  {
    value: "10,000+",
    label: "Active Employees Managed",
    icon: (
      <svg className="w-12 h-12 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
      </svg>
    ),
  },
  {
    value: "98.5%",
    label: "HR Process Automation Rate",
    icon: (
      <svg className="w-12 h-12 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
      </svg>
    ),
  },
  {
    value: "45%",
    label: "Reduction in HR Workload",
    icon: (
      <svg className="w-12 h-12 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
      </svg>
    ),
  },
];

export default function StatsSection() {
  return (
    <section className="relative py-16 md:py-20 bg-gradient-to-br from-blue-50 via-white to-blue-50">
      
      {/* Decorative elements */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,rgba(59,130,246,0.08),transparent_60%)]"></div>
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-blue-200 to-transparent"></div>

      <div className="relative max-w-7xl mx-auto px-6">
       
        <div className="text-center mb-12 md:mb-16">
          {/* Small badge */}
          <div className="inline-flex items-center gap-2 bg-blue-100 text-blue-700 px-4 py-2 rounded-full mb-5">
            <span className="w-2 h-2 bg-blue-600 rounded-full animate-pulse"></span>
            <span className="text-sm font-medium tracking-wide">HR Analytics</span>
          </div>
          
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 tracking-tight">
            Employee Management <span className="text-blue-600">By The Numbers</span>
          </h2>
          <p className="mt-4 text-gray-600 max-w-2xl mx-auto text-base md:text-lg">
            Streamlined HR operations, automated workflows, and data-driven insights 
            for modern workforce management.
          </p>
        </div>

       
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {stats.map((item, index) => (
            <div
              key={index}
              className="group relative rounded-2xl bg-white border border-blue-100 p-8 text-center
                         hover:border-blue-300 hover:shadow-xl
                         transition-all duration-300 ease-out"
            >
              {/* Icon container */}
              <div className="text-blue-500 mb-5 transform group-hover:scale-110 transition-transform duration-300">
                {item.icon}
              </div>

              {/* Value */}
              <h3 className="text-4xl md:text-5xl font-extrabold text-blue-600 mb-2">
                {item.value}
              </h3>

              {/* Label */}
              <p className="text-gray-700 font-medium text-sm md:text-base">
                {item.label}
              </p>

              {/* Decorative line */}
              <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 w-0 h-0.5 bg-blue-500 group-hover:w-12 transition-all duration-300 rounded-full"></div>
            </div>
          ))}
        </div>

        {/* Bottom description */}
        <div className="text-center mt-12">
          <p className="text-gray-500 text-sm">
            Trusted by leading enterprises for intelligent workforce management
          </p>
          <div className="flex justify-center gap-2 mt-3">
            {[...Array(3)].map((_, i) => (
              <div key={i} className="w-1.5 h-1.5 rounded-full bg-blue-300"></div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}